// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"TowerWrapper_Wrapper__3jW4w","Tower":"TowerWrapper_Tower__1M6l7","Inner":"TowerWrapper_Inner__-Jp3_","ComponentsWrap":"TowerWrapper_ComponentsWrap__9WUDF"};